const apiUrl = process.env.VUE_APP_API_BASEURL;

export default {
  donate: `${apiUrl}/v2/donate`,
  booking: `${apiUrl}/v2/booking`,
  bookingPrice: `${apiUrl}/v2/booking/price`,
  housingRegistrationForm: (orderId: string) => `${apiUrl}/v2/booking/${orderId}/registrationForm`,
};
